export const CSAT_MAX_SCORE = 5;

// Scores below this offer a call instead of (or as well as) a written comment.
export const CSAT_LOW_SCORE_CEILING = 3;

// What each star means, shown under the stars as the member hovers or picks one.
export const CSAT_SCORE_LABELS: Record<number, string> = {
    1: 'Very poor',
    2: 'Poor',
    3: 'Okay',
    4: 'Good',
    5: 'Excellent',
};

export const CSAT_FOLLOW_UP_TEXT: Record<number, string> = {
    1: 'Sorry to hear we fell short of your expectations—let us know how we can step it up and do better next time.',
    2: 'We want to make things right—how can we improve to support you better next time?',
    3: "We'd love to amaze you in the future - what would've made today's interaction stellar?",
    4: "Glad you're feeling good - we're always here to help!",
    5: 'So glad we could help! Anything that made it great?',
};
